// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"549369be","977":"52f0d585"}[chunkId] + ".chunk.js";
};